// Functions, Helpers, and Utils
import { Locale, getLocalization } from "../../../helpers/localization";

const CallToAction: React.FC<{ deviceLanguage: Locale }> = ({
  deviceLanguage,
}) => {
  return (
    <div className="call-to-action">
      <h1>{getLocalization("home", "heroQuote1", deviceLanguage)}</h1>
      <h1>{getLocalization("home", "heroQuote2", deviceLanguage)}</h1>
      <h1>
        <span className="gradient-text">{getLocalization("home", "heroQuoteHighlight", deviceLanguage)}</span>
      </h1>
    </div>
  );
};

export default CallToAction;
